import { get, isEqual, set } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';
import { MyVerbale } from '../models/interfaces/revisione.interface';

const restoreIfOverwritten = (current: MyVerbale, imported: MyVerbale, path: string): boolean => {
    const importedValue = get(imported, path);
    if (isEqual(get(current, path), importedValue)) {
        return false;
    }
    set(current, path, importedValue);
    return true;
};

/**
 * Import-only: fields that an on-change listener recomputes while the import repopulates the forms, overwriting the XML value
 * (InfoPath does not run onChange rules on document load). Restores them on `current` (mutated); returns true if any changed.
 * New case → add one line here.
 */
export const restoreImportOverwrittenFields = (current: MyVerbale, imported: MyVerbale): boolean =>
    [
        // 50 - recomputed as floor(ImportoComplessivo) === floor(ImportoVersato): an overpayment (640 on 639.54) turns the XML '1' into '0'
        restoreIfOverwritten(current, imported, `${formPaths.contributoLegge59}.my_CkVersamEffett`),
    ].some(Boolean);
